import { IS_LOCAL_ENV } from '../../configs/featureflags';
import { Language } from '../../configs/language';
import leng from '../../constants/leng';

export type InvoiceTypes = 'payable' | 'receivable';

export const INITIAL_STATE = {
  fromData: '',
  toData: '',
  dateTime: '',
  updatedAt: '',
  dueDateTime: '',
  countryData: '',
  stateData: '',
  totalData: 0,
  itemsData: [],
};

export const TAXES_DATA = 0;
export const URI = IS_LOCAL_ENV ? import.meta.env.VITE_EFEX_BASE_URL : '';

export const HEADER_INVOICE: Record<
  'payable' | 'receivable',
  (language: Language) => { send: string; receive: string }
> = {
  payable: (language) => ({
    send: leng[language].invoicePayableSend,
    receive: leng[language].invoiceRequested,
  }),
  receivable: (language) => ({
    receive: leng[language].invoiceSend,
    send: leng[language].invoiceRequested,
  }),
};
